import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`executive-secretary/dashboard?${query}`)
  }
}

export default DashboardService
